import Vue from 'vue';
import Router from 'vue-router';
import { i18n } from '@/i18n';

Vue.use(Router);

let router = new Router({
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/splash',
      name: 'splash',
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: 'login.title',
        initFrom: 'login',
      },
    },
    {
      path: '/signup',
      name: 'signup',
      meta: {
        title: 'signup.title',
        initFrom: 'login'
      },
    },
    {
      path: '/forget-password',
      name: 'forget-password',
      meta: {
        title: 'forget_pw.title',
        initFrom: 'login'
      },
    },
    {
      path: '/api/users/password/edit',
      name: 'reset-password',
      meta: {
        title: 'reset_pw.title',
        initFrom: 'login'
      },
    },
    {
      path: '/invitation',
      name: 'invitation',
      meta: { initFrom: 'main-tabbar' },
    },
    {
      path: '/api/providers/:provider/open_ids',
      name: 'open-id-callback',
    },
    {
      path: '/',
      name: 'home',
      meta: {
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      meta: {
        title: 'subscriptions.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/downloads',
      name: 'downloads',
      meta: {
        title: 'downloads.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/account',
      name: 'account',
      meta: {
        title: 'account.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/profile-edit',
      name: 'profile-edit',
      meta: {
        title: 'edit_profile.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/change-password',
      name: 'change-password',
      meta: {
        title: 'change_pw.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/notification-settings',
      name: 'notification-settings',
      meta: {
        title: 'notf_settings.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/auto-download-settings',
      name: 'auto-download-settings',
      meta: {
        title: 'auto_download_settings.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/privacy-settings',
      name: 'privacy-settings',
      meta: {
        title: 'privacy_settings.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/skip-rewind-settings',
      name: 'skip-rewind-settings',
      meta: {
        title: 'skip_rewind_settings.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/sleep-timer-settings',
      name: 'sleep-timer-settings',
      meta: {
        title: 'sleep_timer_settings.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/about-us',
      name: 'about-us',
      meta: {
        title: 'about_us.title',
        initFrom: 'any',
      },
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: 'search.title',
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/hosts/:slug/:id',
      name: 'host',
      meta: {
        title: route => { return (route.params && route.params.slug) ? route.params.slug.replace(/-/g, ' ') : ('Host #' + route.params.id); },
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/channels/:slug/:id',
      name: 'channel',
      meta: {
        title: route => { return (route.params && route.params.slug) ? route.params.slug.replace(/-/g, ' ') : ('Channel #' + route.params.id); },
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/episodes/:slug/:id',
      name: 'episode',
      meta: {
        title: route => { return (route.params && route.params.slug) ? route.params.slug.replace(/-/g, ' ') : ('Episode #' + route.params.id); },
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/tags/:slug/:id',
      name: 'tag',
      meta: {
        title: route => { return (route.params && route.params.slug) ? route.params.slug.replace(/-/g, ' ') : ('Tag #' + route.params.id); },
        initFrom: 'main-tabbar',
      },
    },
    {
      path: '/*',
      redirect: { name: 'home' }
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to && to.meta && to.meta.title) {
    let title;
    if (typeof to.meta.title === 'string') {
      title = i18n.t(to.meta.title);
    } else {
      title = to.meta.title(to);
    }
    title = title + ' | ' + i18n.t("site_title");
    document.title = title;
  } else {
    document.title = i18n.t("site_title");
  }
  next();
})

export default router;
